// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3dmym","footer":"ModalFilter_footer__3ecvX"};